export default __webpack_public_path__ + "static/talkWorldfestival-1cf63980dc0820d7edba8e5d23ae39cb.png";